import React from "react";
import { ourTeamInfo } from "../../../mockdata/ourTeamData";
import OurTeamCard from "../../primitive/cards/OurTeamCard";

import { useTranslation } from "react-i18next";

const OurTeam = () => {
  const { t } = useTranslation('about');
  return (
    <div className="container mx-auto py-10 space-y-8 md:space-y-16">
      <div>
        <h2 className="text-4xl sm:text-5xl lg:text-[65px] lg:leading-[4.5rem] font-test-sohne-medium">
          {t('teamBold')}
        </h2>
        <p className="font-test-sohne-light">
        {t('teamLight')}
        </p>
      </div>

      <div className="w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 md:grid-cols-3 gap-4">
          <>
            {ourTeamInfo.map((card, index) => (
              <div key={index}>
                <OurTeamCard
                  image={card.image}
                  name={t(`teamInfo.${index}.name`)}
                  title={t(`teamInfo.${index}.title`)}
                  social_medial_name={t(`teamInfo.${index}.social_medial_name`)}
                  social_media_link={t(`teamInfo.${index}.social_media_link`)}
                  bio={card.bio}
                />
              </div>
            ))}
          </>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
